import React from "react";

const CircleTickGreenIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5341 7.16373C14.8385 8.65793 14.6215 10.2113 13.9193 11.5649C13.2171 12.9185 12.072 13.9904 10.6751 14.6019C9.27816 15.2135 7.71382 15.3276 6.24293 14.9253C4.77205 14.523 3.48353 13.6287 2.59225 12.3913C1.70097 11.154 1.26081 9.64855 1.34518 8.12599C1.42954 6.60342 2.03332 5.15579 3.05583 4.02451C4.07835 2.89323 5.45779 2.14668 6.96411 1.90937C8.47043 1.67205 10.0126 1.9583 11.3334 2.7204"
        stroke="#43B46C"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 7.83073L8 9.83073L14.6667 3.16406"
        stroke="#43B46C"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CircleTickGreenIcon;
